var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "false",
    className: "styles__StyledInlineSvg-sc-12l8vvi-0 jFpckg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.7C0 6.57989 0 6.01984 0.217987 5.59202C0.409734 5.21569 0.715695 4.90973 1.09202 4.71799C1.51984 4.5 2.07989 4.5 3.2 4.5H20.8C21.9201 4.5 22.4802 4.5 22.908 4.71799C23.2843 4.90973 23.5903 5.21569 23.782 5.59202C24 6.01984 24 6.57989 24 7.7V16.3C24 17.4201 24 17.9802 23.782 18.408C23.5903 18.7843 23.2843 19.0903 22.908 19.282C22.4802 19.5 21.9201 19.5 20.8 19.5H3.2C2.0799 19.5 1.51984 19.5 1.09202 19.282C0.715695 19.0903 0.409734 18.7843 0.217987 18.408C0 17.9802 0 17.4201 0 16.3V7.7Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1972 11.9979C20.1972 13.9109 19.0895 15.656 17.3448 16.492C15.6 17.3279 13.5244 17.1081 11.9994 15.9257C13.2217 14.9784 13.9353 13.5302 13.9353 11.9972C13.9353 10.4641 13.2217 9.01592 11.9994 8.06863C13.5244 6.88627 15.6 6.66639 17.3448 7.50237C19.0895 8.33835 20.1972 10.0834 20.1972 11.9965V11.9979Z",
    fill: "#F79E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 8.06885C11.9995 8.06885 11.9995 8.06884 11.9995 8.06885C13.2217 9.01613 13.9353 10.4643 13.9353 11.9974C13.9353 13.5304 13.2217 14.9786 11.9995 15.9259H11.9975C10.7757 14.9791 10.063 13.531 10.0647 11.9984C10.0634 10.4655 10.777 9.01709 11.9998 8.07061C11.999 8.07002 11.9982 8.06943 11.9975 8.06885H11.9995Z",
    fill: "#FF5F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0647 11.9984C10.0634 10.4654 10.777 9.01701 11.9998 8.07053C9.92249 6.46054 6.93945 6.69505 5.14704 8.60925C3.35463 10.5235 3.35463 13.4747 5.14704 15.3889C6.93945 17.3031 9.92249 17.5376 11.9998 15.9276C10.7766 14.9808 10.063 13.5318 10.0647 11.9984Z",
    fill: "#EB001B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.b5a80e1db4cc785f23881cc3d07fa109.svg";
export { ForwardRef as ReactComponent };